import IconButton from 'components/IconButton';
import React, { useState } from 'react';

import AssigneeModal from './AssigneeModal';
import FindingDetailModal from './FindingDetailModal';
import FindingNotesModal from './FindingNotesModal';
import IgnoreVulnModal from './IgnoreVulnModal';
import { SourceType } from './state';
import UnignoreVulnModal from './UnignoreVulnModal';
import WatcherModal from './WatcherModal';

const RowActions = ({ rowData }) => {
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [isNotesModalOpen, setIsNotesModalOpen] = useState(false);
  const [isIgnoreModalOpen, setIsIgnoreModalOpen] = useState(false);
  const [isUnignoreModalOpen, setIsUnignoreModalOpen] = useState(false);
  const [isWatcherModalOpen, setIsWatcherModalOpen] = useState(false);
  const [isAssigneeModalOpen, setIsAssigneeModalOpen] = useState(false);

  const handleViewDetailsClick = () => {
    setIsDetailsModalOpen(true); // Open the modal
  };

  const handleCloseModal = () => {
    setIsDetailsModalOpen(false); // Close the modal
  };

  const notesTooltip = (
    <span>{`${
      rowData.notes_count > 0 ? rowData.notes_count + ' Existing notes. ' : ''
    }Click to add notes`}</span>
  );

  const enableIgnoreButton =
    rowData.status !== 'FIXED' &&
    (rowData.source_type === SourceType.WAS ||
      rowData.source_type === SourceType.SAST ||
      rowData.source_type === SourceType.EP); /*||
      ((rowData.source_type === 'ca_data' ||
        rowData.source_type === 'ca_data-workstations' ||
        rowData.source_type === 'ca_data-all') &&
        rowData.ca_is_tagged
      )*/
  const enableUnignoreButton =
    rowData.source_type === SourceType.WAS ||
    rowData.source_type === SourceType.SAST ||
    rowData.source_type === SourceType.EP; /*||
    ((rowData.source_type === 'ca_data' ||
      rowData.source_type === 'ca_data-workstations' ||
      rowData.source_type === 'ca_data-all') &&
      rowData.ca_is_tagged); */

  return (
    <div>
      <IconButton
        id="vulnLink"
        iconClass="fa fa-eye"
        size="sm"
        tooltip="View Details"
        onClick={handleViewDetailsClick}
      />
      <IconButton
        id="vuln_add_notes"
        iconClass="tim-icons icon-chat-33"
        size="sm"
        tooltip={notesTooltip}
        onClick={() => setIsNotesModalOpen(true)} // Open notes modal on click
        countBadge={rowData.notes_count}
      />
      <IconButton
        id="vuln_assignee"
        iconClass="fa fa-user-plus"
        size="sm"
        tooltip="Click to assign/unassign"
        onClick={() => setIsAssigneeModalOpen(true)}
      />
      <IconButton
        id="vuln_watcher"
        iconClass="fa fa-users"
        size="sm"
        tooltip="Click to add/remove watchers"
        onClick={() => setIsWatcherModalOpen(true)} // Open watcher modal on click
        countBadge={rowData.watcher_count}
      />
      {rowData.is_ignored && (
        <IconButton
          id="vuln_unignore_btn"
          iconClass="fa fa-circle-check"
          size="sm"
          tooltip="Unignore this vulnerability"
          onClick={() => setIsUnignoreModalOpen(true)}
          disabled={!enableUnignoreButton}
        />
      )}
      {!rowData.is_ignored && (
        <IconButton
          id="vuln_ignore_btn"
          iconClass="fa fa-ban"
          size="sm"
          tooltip="Ignore this vulnerability"
          onClick={() => setIsIgnoreModalOpen(true)}
          disabled={!enableIgnoreButton}
        />
      )}
      {isDetailsModalOpen && (
        <FindingDetailModal onClose={handleCloseModal} id={rowData['id']} />
      )}
      {isNotesModalOpen && (
        <FindingNotesModal
          onClose={() => setIsNotesModalOpen(false)}
          finding={rowData}
        />
      )}
      {isIgnoreModalOpen && (
        <IgnoreVulnModal
          finding={rowData}
          isOpen={isIgnoreModalOpen}
          toggle={() => setIsIgnoreModalOpen(!isIgnoreModalOpen)}
        />
      )}
      {isUnignoreModalOpen && (
        <UnignoreVulnModal
          finding={rowData}
          isOpen={isUnignoreModalOpen}
          toggle={() => setIsUnignoreModalOpen(!isUnignoreModalOpen)}
        />
      )}
      {isWatcherModalOpen && (
        <WatcherModal
          finding={rowData}
          isOpen={isWatcherModalOpen}
          toggle={() => setIsWatcherModalOpen(!isWatcherModalOpen)}
        />
      )}
      {isAssigneeModalOpen && (
        <AssigneeModal
          finding={rowData}
          isOpen={isAssigneeModalOpen}
          toggle={() => setIsAssigneeModalOpen(!isAssigneeModalOpen)}
        />
      )}
    </div>
  );
};

export default RowActions;
